import { Box, Checkbox, FormControlLabel, Stepper, Step } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useCallback, useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { loadAction } from "redux/reducers/top";
import { loadDataAction } from "redux/reducers/setting/password";
import { useForm } from "react-hook-form";
import OriginPwd from "components/setting/password/originPassword";
import NewPwd from "components/setting/password/newPassword";

export default function Password(props) {
  const dispatch = useDispatch();
  const { member } = useSelector((state) => state.settingPassword);

  useEffect(async () => {
    dispatch(loadDataAction());
    dispatch(
      loadAction({ back: true, title: "간편 비밀번호 설정", menu: false })
    );
  }, []);

  return (
    <main id="main" className="container nopad">
      <div className="layout-flex">
        <div className="layout-body login-body">
          {member && (member.pwd ? <OriginPwd /> : <NewPwd />)}
        </div>
      </div>
    </main>
  );
}
